import { render, staticRenderFns } from "./EventReviewPurchaseModalFooter.vue?vue&type=template&id=2bf49b8c&scoped=true&"
import script from "./EventReviewPurchaseModalFooter.vue?vue&type=script&lang=js&"
export * from "./EventReviewPurchaseModalFooter.vue?vue&type=script&lang=js&"
import style0 from "./EventReviewPurchaseModalFooter.vue?vue&type=style&index=0&id=2bf49b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf49b8c",
  null
  
)

export default component.exports